module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$store.getters.isSdkValid) ? _c('div', {
    staticClass: "instruction-content"
  }, [(_vm.index) ? _c('div', [_c('h3', {
    staticClass: "instruction-subheader"
  }, [_vm._v("1. Remove Old Rotator Code")]), _vm._v(" "), _c('p', {
    staticClass: "instruction-paragraph"
  }, [_vm._v("Your page includes a Rotator SDK that is either outdated or tied to a different rotation group. Find and remove the following code before continuing.")]), _vm._v(" "), _c('div', {
    staticClass: "code-preview"
  }, [_c('p', {
    attrs: {
      "id": "code-explanation"
    }
  }, [(_vm.$store.state.rotator.script_location) ? _c('pre', [_vm._v(_vm._s(_vm.$store.state.rotator.script_location[0])), _c('div', {
    staticClass: "existing-sdk"
  }, [_vm._v(_vm._s("\n" + _vm.$store.state.rotator.script_location[1] + "\n"))]), _vm._v(_vm._s(_vm.$store.state.rotator.script_location[2]))]) : _c('pre', [_vm._v("            <!DOCTYPE HTML>\n            <html>\n                <head>\n                    "), _c('div', {
    staticClass: "existing-sdk"
  }, [_vm._v(_vm._s("\n" + this.$store.getters.sdk() + "\n\n"))]), _vm._v("\n                    ....\n                </head>\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "instruction-subheader"
  }, [_vm._v(_vm._s(_vm.index + 1) + ". Copy Rotator SDK")]), _vm._v(" "), _c('p', {
    staticClass: "instruction-paragraph"
  }, [_vm._v("Copy the code below, which is unique to this page.")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.$store.state.rotator.template_id),
      expression: "!$store.state.rotator.template_id"
    }],
    staticClass: "code-preview",
    attrs: {
      "element-loading-text": "Loading..."
    }
  }, [_c('textarea', {
    attrs: {
      "id": "code-top-copy",
      "rows": "5"
    }
  }, [_vm._v(_vm._s(this.$store.getters.sdk()))]), _vm._v(" "), _c('div', {
    staticClass: "tool-bar__default row"
  }, [_c('button', {
    staticClass: "copy-btn__default",
    style: ({
      'background-color': [_vm.copied == true ? 'green' : '#9c9c9c']
    }),
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v(_vm._s(_vm.copyButton))])])]), _vm._v(" "), _c('h3', {
    staticClass: "instruction-subheader"
  }, [_vm._v(_vm._s(_vm.index + 2) + ". Place Rotator SDK")]), _vm._v(" "), _c('p', {
    staticClass: "instruction-paragraph"
  }, [_vm._v("Paste the copied code into the top of your webpage source, just below the opening <head> tag.")]), _vm._v(" "), _c('div', {
    staticClass: "code-preview"
  }, [_c('p', {
    attrs: {
      "id": "code-explanation"
    }
  }, [_c('pre', [_vm._v("<!DOCTYPE HTML>\n<html>\n    <head>\n        "), _c('div', {
    staticClass: "new-sdk"
  }, [_vm._v(_vm._s("\n" + this.$store.getters.sdk().replace(/^(\s*[^\s])/mg, function (s) { return "        " + s; }) + "\n\n"))]), _vm._v("\n        ....\n    </head>\n        ")])])]), _vm._v(" "), _c('h3', {
    staticClass: "instruction-subheader"
  }, [_vm._v(_vm._s(_vm.index + 3) + ". Verify Setup")]), _vm._v(" "), _c('p', {
    staticClass: "instruction-paragraph"
  }, [_vm._v("After publishing your page with above changes, click on the button below to verify that the script is installed and running correctly.")]), _vm._v(" "), _c('button', {
    staticClass: "form-button__default form-button__largetext",
    on: {
      "click": function($event) {
        _vm.liveDetect()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(this.$store.state.rotator.sdkDetection) ? _c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])]) : _c('div', [_vm._v("Test Integration")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.errorMessage,
    staticClass: "error-sdk"
  }, [_c('p', {
    staticClass: "instruction-paragraph"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])])], 1) : _c('div', [_c('div', {
    staticClass: "instruction-content"
  }, [_c('h2', {
    staticClass: "instruction-notice"
  }, [_vm._v("Congratulations! A valid Rotator SDK was detected on this page.")]), _vm._v(" "), _c('h3', {
    staticClass: "instruction-subheader"
  }, [_vm._v("1. Save Changes")]), _vm._v(" "), _c('p', {
    staticClass: "instruction-paragraph"
  }, [_vm._v("No code modifications are required. If you're satisfied with the changes you've made, simply click on the \"SAVE\" button below and they will be published instantly.")]), _vm._v(" "), _c('button', {
    staticClass: "form-button__default form-button__largetext",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.saving) ? _c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])]) : _c('div', [_vm._v("Save")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveMessage),
      expression: "saveMessage"
    }],
    staticClass: "error-sdk"
  }, [_vm._v(_vm._s(_vm.saveMessage))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70627ce0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/Instruction.vue
// module id = Oxjp
// module chunks = 1